import { createContext } from 'react';
import { WeeklySchedule } from '../../weeklySchedule/weekly.schedule.model';

export type LaborableContextType = {
    weeklySchedule: WeeklySchedule;
    bookingStep: number;
    refreshLaborable: () => Promise<void>
}

export const LaborableContext = createContext<LaborableContextType>(null);